<template>
    <SideNav ref="sidenav" class="cookie">
        <div class="header">
            <div class="corner">
                <div class="corner-inner">
                    <div class="back"></div>
                    <div class="title">Cookie</div>
                </div>
            </div>

            <div class="adhoc">
                <div class="adhoc-wrapper">
                    <div class="adhoc-content">
                        <div class="close" @click="close"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle">
            <div class="text-block">
                Ку́ки (англ. cookie) — небольшой фрагмент данных, отправленный веб-сервером и хранимый на компьютере
                пользователя. Веб-клиент (обычно веб-браузер) всякий раз при попытке открыть страницу соответствующего
                сайта пересылает этот фрагмент данных веб-серверу в составе HTTP-запроса.
            </div>
            <div class="text-block">
                Большинство современных браузеров позволяет пользователям выбрать — принимать куки или нет,
                но их отключение делает невозможной корректную работу с нашим сайтом.
            </div>
            <div class="text-block">
                Как мы обрабатываем Ваши Cookies?
                Наш сайт обрабатывает полученные данные, в том числе, с использованием метрических программ
                и систем аналитики, таких как Яндекс.Метрика.
            </div>
            <div class="text-block">
                <a class="primary" href="https://msk.rt.ru/legal" target="_blank">Условия обработки информации о
                    пользователях</a>
            </div>
        </div>
        <div class="footer">
            <input class="ghost close" type="button" value="Закрыть" @click="close" />
        </div>
    </SideNav>
</template>

<script>
export default {
    name: 'Cookie',
    methods: {
        open() {
            this.$refs.sidenav.open();
        },
        close() {
            this.$refs.sidenav.cancel();
        },
    },
};
</script>


<style lang="scss" scoped>
.cookie {
    .text-block {
        margin-bottom: 20px;
        font-size: 16px;
    }
}
</style>
